var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header clearfix" }, [
    _c("nav", { staticClass: "navbar", attrs: { href: "#/" } }, [
      _c("a", { staticClass: "navbar-brand" }, [
        !_vm.tenant.appLogo
          ? _c("img", { attrs: { src: _vm.defLogo } })
          : _vm._e(),
        _vm._v(" "),
        _vm.tenant.appLogo
          ? _c("img", { attrs: { src: _vm.tenant.appLogo } })
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoggedIn
          ? _c("span", { staticClass: "text-muted" }, [
              _vm._v(
                _vm._s(_vm.tenant.appName || "GST EWaybill") + "\n        "
              ),
              !_vm.tenant.appLogo
                ? _c("span", [_vm._v(" - " + _vm._s(_vm.tenant.name))])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isLoggedIn ? _c("span", [_vm._v("Login")]) : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", {}, [
        _vm.isLoggedIn
          ? _c(
              "ul",
              { staticClass: "nav nav-pills" },
              [
                _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link",
                        attrs: { "exact-active-class": "active", to: "/" }
                      },
                      [_vm._v("Dashboard")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ewbTenant
                  ? _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: { "active-class": "active", to: "/generate" }
                          },
                          [_vm._v("Generate")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.podTenant
                  ? _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              "active-class": "active",
                              to: "/manage-pod"
                            }
                          },
                          [_vm._v("Manage POD")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.podTenant && !_vm.isTransporter && !_vm.isCustomer
                  ? _c(
                      "b-dropdown",
                      {
                        attrs: { text: "Transporter Portals", variant: "link" }
                      },
                      _vm._l(_vm.transporters, function(t) {
                        return t.trackingPage
                          ? _c(
                              "b-dropdown-item",
                              {
                                key: t.id,
                                attrs: {
                                  href: t.trackingPage,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(t.name))]
                            )
                          : _vm._e()
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.ewbTenant
                  ? _c(
                      "b-dropdown",
                      { attrs: { text: "EWaybill", variant: "link" } },
                      [
                        _c("b-dropdown-item", { attrs: { to: "/reports" } }, [
                          _vm._v("Reports")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          { attrs: { to: "/reconciliation" } },
                          [_vm._v("Reconciliation")]
                        ),
                        _vm._v(" "),
                        _c("b-dropdown-item", { attrs: { to: "/validate" } }, [
                          _vm._v("Validate GSTIN")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdminLoggedIn && !_vm.isCustomer
                  ? _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: { "active-class": "active", to: "/admin" }
                          },
                          [_vm._v("Admin")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLocalAdmin
                  ? _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: { "active-class": "active", to: "/users" }
                          },
                          [_vm._v("Admin")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isCustomer
                  ? _c(
                      "b-dropdown",
                      { attrs: { text: "Help", variant: "link" } },
                      [
                        _vm.isTransporter ||
                        _vm.isLocalAdmin ||
                        _vm.isAdminLoggedIn
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  href:
                                    "https://docs.google.com/document/d/1pVkjtSwqZ4nP7WfVRQ6AT5Sbzn0lhJC7RVNC32dCjo0/edit?usp=sharing",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Transporter User Manual")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLocalAdmin || _vm.isAdminLoggedIn
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  href:
                                    "https://docs.google.com/document/d/1kgiUL2lpPrOseBa4grFI2-_Ke3EKiQaDF-hoKq8AVac/edit?usp=sharing",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Local Admin User Manual")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isAdminLoggedIn
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  href:
                                    "https://docs.google.com/document/d/1Tj6YY0oU2C_J4ctdvQleSsqSWLo4HEkcY3HOQsD1Ihs/edit?ts=5ce256b2#",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Admin User Manual")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isTransporter
                          ? _c(
                              "b-dropdown-item",
                              { attrs: { to: "/contacts" } },
                              [_vm._v("Contact Details")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-dropdown",
                  { attrs: { text: _vm.user.name, variant: "link" } },
                  [
                    _c("b-dropdown-item", { attrs: { href: "#/logout" } }, [
                      _vm._v("Logout")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.podTenant
        ? _c("span", { staticClass: "navbar-text ml-2" }, [
            _vm._v(
              "\n      Last Updated : " + _vm._s(_vm.lastUpdate) + "\n    "
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb50a5e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb50a5e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = null
// module chunks = 